import { TFunction } from 'react-i18next';
import * as Yup from 'yup';
import { Shape } from '../yup_types';

export enum DEVELOPER_FORM_FIELDS {
	FIRST_NAME = 'DeveloperFirstName',
	LAST_NAME = 'DeveloperLastName',
	EMAIL = 'DeveloperEmail',
	PHONE = 'DeveloperPhone',
}

export enum DEVELOPER_FORM_FIELDS_NAMES {
	FIRST_NAME = 'NEW_APPLICATION.LABEL.FIRST_NAME',
	LAST_NAME = 'NEW_APPLICATION.LABEL.LAST_NAME',
	EMAIL = 'NEW_APPLICATION.LABEL.EMAIL',
	PHONE = 'NEW_APPLICATION.LABEL.PHONE',
}

// @ts-ignore
export const getDeveloperValidationSchema = (t: TFunction): Yup.SchemaOf<DeveloperFieldsTypes> => Yup.object<Shape<DeveloperFieldsTypes>>().shape({
	[DEVELOPER_FORM_FIELDS.FIRST_NAME]: Yup.string(),
	[DEVELOPER_FORM_FIELDS.LAST_NAME]: Yup.string(),
	[DEVELOPER_FORM_FIELDS.EMAIL]: Yup.string()
		.email(t('NEW_APPLICATION.VALIDATION.EMAIL_ERROR_TEXT')),
	[DEVELOPER_FORM_FIELDS.PHONE]: Yup.number()
		.test('is-valid-phone', t('NEW_APPLICATION.VALIDATION.VALID_PHONE'), (value) => {
      if (!value) return true;
      const phoneRegex = /^[0-9]{10,15}$/;
      return phoneRegex.test(value.toString());
    })
		.typeError(t('NEW_APPLICATION.VALIDATION.NUMBER_ERROR_TEXT')),
});

export type DeveloperFieldsTypes = {
	[DEVELOPER_FORM_FIELDS.FIRST_NAME]: string;
	[DEVELOPER_FORM_FIELDS.LAST_NAME]: string;
	[DEVELOPER_FORM_FIELDS.EMAIL]: string;
	[DEVELOPER_FORM_FIELDS.PHONE]: string;
}

export type DeveloperFieldReturnTypes = {
	developerFirstName: string;
	developerLastName: string;
	developerEmail: string;
	developerPhone: string;
}

export const initialDeveloperValues: DeveloperFieldsTypes = {
	[DEVELOPER_FORM_FIELDS.FIRST_NAME]: '',
	[DEVELOPER_FORM_FIELDS.LAST_NAME]: '',
	[DEVELOPER_FORM_FIELDS.EMAIL]: '',
	[DEVELOPER_FORM_FIELDS.PHONE]: '',
};

	export const getFormattedDeveloperFormFields = (formikValues): DeveloperFieldReturnTypes => ({
		developerFirstName: formikValues?.[DEVELOPER_FORM_FIELDS.FIRST_NAME],
		developerLastName: formikValues?.[DEVELOPER_FORM_FIELDS.LAST_NAME],
		developerEmail: formikValues?.[DEVELOPER_FORM_FIELDS.EMAIL],
		developerPhone: formikValues?.[DEVELOPER_FORM_FIELDS.PHONE] ?? null,
	});

export const convertToDeveloperInitial = (data): DeveloperFieldsTypes => ({
	[DEVELOPER_FORM_FIELDS.FIRST_NAME]: data?.developerContact?.developerFirstName ? data?.developerContact?.developerFirstName : '',
	[DEVELOPER_FORM_FIELDS.LAST_NAME]: data?.developerContact?.developerLastName ? data?.developerContact?.developerLastName : '',
	[DEVELOPER_FORM_FIELDS.EMAIL]: data?.developerContact?.developerEmail ? data?.developerContact?.developerEmail : '',
	[DEVELOPER_FORM_FIELDS.PHONE]: data?.developerContact?.developerPhone ? data?.developerContact?.developerPhone : '',
});

export const getFormattedDeveloperData = (data): DeveloperFieldReturnTypes => ({
	developerFirstName: data?.developerContact?.developerFirstName,
	developerLastName: data?.developerContact?.developerLastName,
	developerEmail: data?.developerContact?.developerEmail,
	developerPhone: data?.developerContact?.developerPhone,
});


